import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LoginIcon from "@mui/icons-material/Login";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  LinkCodeWidgetButton,
  LinkCodeWidgetButtonIcon,
} from "functions/linkCode";
import React from "react";

const BUTTON_ICONS: Record<
  LinkCodeWidgetButtonIcon,
  React.ComponentType<{ sx?: object }>
> = {
  phone: PhoneInTalkOutlinedIcon,
  recharge: AccountBalanceWalletOutlinedIcon,
  login: LoginIcon,
};

interface Props {
  button: LinkCodeWidgetButton;
  isActive?: boolean;
  onClick: () => void;
}

const LinkCodeActionButton: React.FC<Props> = ({
  button,
  isActive = false,
  onClick,
}) => {
  const Icon = BUTTON_ICONS[button.icon];

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        p: 1.25,
        mb: 1,
        border: "1.5px solid",
        borderColor: isActive ? "primary.main" : "#1f1f1f",
        borderRadius: "12px",
        bgcolor: isActive ? "rgba(253, 157, 14, 0.08)" : "#fff",
        cursor: "pointer",
        textAlign: "left",
        transition: "background-color 0.2s ease",
        "&:hover": {
          bgcolor: "#fafafa",
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "10px",
          bgcolor: "rgba(253, 157, 14, 0.18)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon sx={{ color: "primary.main", fontSize: 22 }} />
      </Box>

      <Typography
        className="fm-poppins"
        sx={{
          flex: 1,
          fontWeight: 700,
          fontSize: "1rem",
          color: "#1f1f1f",
        }}
      >
        {button.label}
      </Typography>

      <ChevronRightIcon sx={{ color: "#9e9e9e", flexShrink: 0 }} />
    </Box>
  );
};

export default LinkCodeActionButton;
